module.exports = __webpack_public_path__ + "img/pcnservices.60a9ea11.svg";